<template>
  <panel-navigation>
    <!-- Top filters (unchanged) -->
    <div v-show="false" v-if="!loading" class="rg-top-filter pt-1 float-right pl-3" :class="(($vuetify.breakpoint.mobile) ? '-mt-2' : '')">
      <v-text-field
        :value="formatDate(date_filter[0], 'MMM DD, YYYY') + '   -   ' + ((date_filter[1]) ? formatDate(date_filter[1], 'MMM DD, YYYY') : '')"
        append-icon="mdi-calendar-blank-outline"
        readonly
        outlined
        dense
        style="width: 230px; background: #4EC5A1; color: #FFFFFF !important; border: 0px !important;"
        hide-details
        @click="show_picker = !show_picker"
      ></v-text-field>

      <div
        v-if="show_picker"
        style="position: absolute; width: 490px; z-index: 999; margin-left: -260px; background: #FFFFFF; padding: 10px; margin-top: 5px; border-radius: 10px; box-shadow: 0px 0px 30px 0px #E2E2E2;"
      >
        <div style="float: left; border-right: solid 1px #d5d5d5;">
          <div class="mb-2"><strong class="text-sm">Filter by Date</strong></div>
          <v-date-picker v-model="date_filter" range no-title scrollable style="border: 0px;">
            <v-spacer></v-spacer>
            <v-btn text color="#44468F" @click="show_picker = false">Cancel</v-btn>
            <v-btn text color="#44468F" @click="filterDate()">UPDATE</v-btn>
          </v-date-picker>
        </div>
        <div style="float: left; margin-left: 20px; padding-left: 20px; padding-top: 20px;">
          <div class="mb-2" v-for="p in presets" :key="p">
            <a href="javascript:void(0);" @click="applyDate(p)" :style="presetStyle(p)">{{ p }}</a>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>

    <div v-show="false" v-if="!loading" class="rg-top-filter pt-1 float-right">
      <v-select
        outlined dense hide-details
        class="white header-inputs"
        :items="['Frequency: Auto','Daily','Weekly','Monthly','Yearly']"
        v-model="selected_frequency"
        @change="loadDashboard()"
      />
    </div>

    <h1 v-if="!loading" class="text-lg font-semibold mb-3">
      {{ me.company_name }} <span style="font-size:14px">- ROI Dashboard</span>
    </h1>

    <v-container v-if="loading" style="padding:10px"><v-skeleton-loader type="article"/></v-container>

    <div v-if="!loading" class="pt-3">

      <!-- ROW 1 -->
      <div class="flex flex-row flex-wrap mt-2">
        <div class="dashboard-box w-full lg:w-1/2 pr-3">
          <v-card class="pa-4 metric-card" tile>
	          <v-icon class="card-icon">mdi-clock-outline</v-icon>
	          <div class="card-title">Labor Minutes Back</div>
            <div class="value">{{ numberWithCommas(cards.labor_minutes_back || 0) }}</div>
            <div class="subtitle">Estimated minutes saved by AI handling calls</div>
          </v-card>
        </div>
        <div class="dashboard-box w-full lg:w-1/2">
          <v-card class="pa-4 metric-card" tile>
              <v-icon class="card-icon">mdi-handshake-outline</v-icon>
              <div class="card-title">New Opportunities</div>
            <div class="value">{{ numberWithCommas(cards.new_opportunities_total || 0) }}</div>
            <div class="subtitle">After hours + weekends (AI only)</div>
          </v-card>
        </div>
      </div>

      <!-- ROW 2 -->
      <div class="flex flex-row flex-wrap mt-4">
        <!-- Successful AI Interactions -->
        <div class="dashboard-box w-full lg:w-1/6 pr-3">
          <v-card class="pa-4 metric-card tall" tile>
            <div class="card-title mb-5">Successful AI Interactions</div>
            <apexchart type="donut" height="220" :options="donutSuccessOptions" :series="donutSuccessSeries" />
            <div class="center-metric mt-5">{{ cards.successful_ai_interactions_rate || '0.00' }}%</div>
          </v-card>
        </div>

        <!-- AI Response Rate -->
        <div class="dashboard-box w-full lg:w-1/6 pr-3">
          <v-card class="pa-4 metric-card tall" tile>
            <div class="card-title mb-16">AI Response Rate</div>
            <div class="mt-3">Human</div>
            <v-progress-linear :value="parseFloat(cards.human_response_rate||0)" height="30" color="#6c757d" />
            <div class="mt-3">AI</div>
            <v-progress-linear :value="parseFloat(cards.ai_response_rate||0)" height="30" color="#3498db" />
            <div class="center-metric mt-16">{{ cards.ai_response_rate || '0.00' }}%</div>
          </v-card>
        </div>

        <!-- Agent Performance Over Time -->
        <div class="dashboard-box w-full lg:w-4/6">
          <v-card class="pa-4 metric-card tall" tile>
            <div class="card-title mb-2">Agent Performance Over Time</div>
            <apexchart type="line" height="260" :options="lineChartSuccessOptions" :series="agentPerformanceSeries" />
          </v-card>
        </div>
      </div>

      <!-- ROW 3 -->
      <div class="flex flex-row flex-wrap mt-4">
        <!-- Types of New Opportunities -->
        <div class="dashboard-box w-full lg:w-1/4 pr-3">
		  <v-card class="pa-4 metric-card d-flex flex-column" tile style="height: 340px;">
		    <div class="card-title mb-2">Types of New Opportunities</div>

		    <div class="flex-grow-1 d-flex align-center justify-center">
		      <apexchart
		        type="donut"
		        height="272"
		        :options="donutOppOptions"
		        :series="donutOppSeries"
		      />
		    </div>
		  </v-card>
		</div>

        <!-- New opportunities over time -->
        <div class="dashboard-box w-full lg:w-3/4">
          <v-card class="pa-4 metric-card" tile style="height: 340px;">
            <div class="card-title mb-2">New Opportunities Over Time</div>
            <apexchart type="line" height="260" :options="lineChartOpportunitiesOptions" :series="lineChartOpportunitiesSeries" />
          </v-card>
        </div>
      </div>

    </div>
  </panel-navigation>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  components:{ apexchart:VueApexCharts, PanelNavigation },
  computed:{ ...mapState({ me: s=>s.me.me }), cards(){return this.roi_dashboard_data.cards||{}} },
  data(){return{
    loading:true,
    selected_frequency:'Monthly',
    show_picker:false,
    date_filter:[moment().subtract(6,'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    presets:['This Week','Last Week','This Month','Last Month','Last 30 days','Last 60 days','Last 90 days','This Year','Last Year','All Time'],
    roi_dashboard_data:{ cards:{}, charts:{ success_over_time:{labels:[],datasets:{}}, opportunities_over_time:{labels:[],datasets:{}} } },

    donutSuccessOptions:{ labels:['Successful','Unsuccessful'], colors:['#3498db','#e5ecf6'], legend:{show:false}, dataLabels: { enabled: false } },
    donutSuccessSeries:[0,0],

    donutOppOptions:{ labels:['Missed','Weekends'], colors:['#27ae60','#7bed9f'], dataLabels: { enabled: false } },
    donutOppSeries:[0,0],

    lineChartSuccessOptions:{ chart:{toolbar:{show:false}}, xaxis:{categories:[]}, stroke:{curve:'smooth'}, colors: ["#5386ed", "#9fb5e3"] },
    agentPerformanceSeries:[],

    lineChartOpportunitiesOptions:{ chart:{toolbar:{show:false}}, xaxis:{categories:[]}, stroke:{curve:'smooth'}, colors: ["#0c9651", "#7df57f"] },
    lineChartOpportunitiesSeries:[]
  }},
  mounted(){ this.loadDashboard() },
  methods:{
    numberWithCommas(x){ if(x===null||x===undefined) return '0'; return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
    formatDate(d,f){ return moment(d).format(f) },
    presetStyle(n){ return this.selected_date_text===n?'font-weight:bold':'' },

    async loadDashboard(){
      this.loading=true
      const res = await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/me/get-roi-dashboard-data`,
        {
          start_date: this.date_filter[0],
          end_date: this.date_filter[1],
          all_time: this.all_time,
          selected_frequency: this.selected_frequency,
        },
        {
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.jwt,
          },
        }
      );
      this.roi_dashboard_data = res.data.roi_dashboard_data
      this.buildCharts()
      this.loading=false
    },

    buildCharts(){
      const c=this.roi_dashboard_data.cards
      this.donutSuccessSeries=[ parseFloat(c.successful_ai_interactions_rate||0), 100-parseFloat(c.successful_ai_interactions_rate||0) ]
      this.donutOppSeries=[ c.after_hours_opportunities||0, c.weekend_opportunities||0 ]

      const labels=this.roi_dashboard_data.charts.success_over_time.labels||[]
      const ds=this.roi_dashboard_data.charts.success_over_time.datasets||{}
      this.lineChartSuccessOptions.xaxis.categories=labels
      this.agentPerformanceSeries=[
        { name:'Successful Interactions', data: ds['Successful AI Interactions']||[] },
        { name:'AI Response Rate', data: ds['Success Rate']||[] }
      ]

      const oppLabels=this.roi_dashboard_data.charts.opportunities_over_time.labels||[]
      const oppDs=this.roi_dashboard_data.charts.opportunities_over_time.datasets||{}
      this.lineChartOpportunitiesOptions.xaxis.categories=oppLabels
      this.lineChartOpportunitiesSeries=[
        { name:'Off the clock/Missed opportunities', data: oppDs['After Hours']||[] },
        { name:'Weekend Opportunities', data: oppDs['Weekends']||[] }
      ]
    }
  }
}
</script>

<style scoped>
.metric-card{ background:#fff; border-radius:12px; box-shadow:0 6px 18px rgba(0,0,0,0.04) }
.metric-card.tall{ min-height:380px }

.card-header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:8px;
}

.card-title{
  font-weight:600;
  font-size:15px;
  color:#2c3e50;
}

.card-icon{
  background:#f1f3f6;
  border-radius:10px;
  padding:6px;
  font-size:40px;
  color:#6c757d;
  float: right;
}

.metric-card .value{ font-size:32px; font-weight:800; margin-top:4px }
.metric-card .subtitle{ color:#6c757d; font-size:13px }

.center-metric{
  text-align:center;
  font-size:28px;
  font-weight:800;
  margin-top:-10px;
}
</style>
